var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-switch',_vm._b({staticClass:"my-switch",attrs:{"active-value":1,"inactive-value":0,"active-icon-class":"choose","inactive-icon-class":"close"},on:{"change":function($event){return _vm.change($event)}}},'el-switch',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }